import { useEffect, useState } from 'react'

// Tracks which in-page section is currently active based on scroll position.
// Single source of truth shared by the desktop Navbar and the mobile BottomNav
// so their active states never disagree. Mirrors the original Navbar logic:
// iterate sections bottom→top and pick the first whose top has passed `offset`.
const useActiveSection = (sectionIds, offset = 120) => {
  const [activeId, setActiveId] = useState(sectionIds[0])

  useEffect(() => {
    const handleScroll = () => {
      for (let i = sectionIds.length - 1; i >= 0; i--) {
        const el = document.getElementById(sectionIds[i])
        if (el && el.getBoundingClientRect().top <= offset) {
          setActiveId(sectionIds[i])
          return
        }
      }
      setActiveId(sectionIds[0])
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
    // sectionIds is a stable literal from constants; join to satisfy exhaustive-deps
  }, [sectionIds, offset])

  return activeId
}

export default useActiveSection
